import Alert from 'components/Alert';
import { constants } from 'helpers/constants';
import React from 'react';

export default class Blinket {
  static isBlinket = (partnerId: number) => partnerId === constants.productPartners.blinket;

  static blinketModal = async () => {
    const confirm = await Alert.confirm({
      message: 'Essa configuração deve ser feita na Blinket. Deseja continuar?',
      title: 'Produto Blinket',
      confirmation: true,
      buttonOk: <>Ir para a Blinket</>,
      buttonCancel: <>Cancelar</>,
    });

    if (confirm) Blinket.openBlinket();
  };

  static openBlinket = () => window.open('https://app.blinket.com.br', '_blank');
}
